import script from "./DepartmentIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentIndex.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentIndex.vue?vue&type=style&index=0&id=d533c890&lang=css"
import "./DepartmentIndex.vue?vue&type=style&index=1&id=d533c890&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d533c890"]])

export default __exports__